import React from 'react'

function Areadetail() {
  return (
    <div>Areadetail</div>
  )
}

export default Areadetail